import angular from 'angular';
import rbLoading from './rb-loading/rb-loading.cmp'
import rbError from './rb-error/rb-error.cmp'
import rbDropdown from './rb-dropdown/rb-dropdown.cmp'
import rbIcon from './rb-icon/rb-icon.cmp'
import rbProgressBar from './rb-progress-bar/rb-progress-bar.cmp'

export default angular.module('rb.components', [])
  .component('rbLoading', rbLoading)
  .component('rbError', rbError)
  .component('rbDropdown', rbDropdown)
  .component('rbIcon', rbIcon)
  .component('rbProgressBar', rbProgressBar)





